import React from 'react';

export const TableEmpty = ({ icon: Icon, title, subtitle, testId }) => (
    <div className="flex flex-col items-center justify-center text-center px-6 py-14" data-testid={testId}>
        <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{ backgroundColor: 'var(--brand-rose)' }}>
            {Icon && <Icon className="w-5 h-5" style={{ color: 'var(--brand-burgundy)' }} />}
        </div>
        <p className="font-serif text-lg" style={{ color: 'var(--brand-burgundy)' }}>{title}</p>
        {subtitle && <p className="text-xs mt-1.5 max-w-xs" style={{ color: 'var(--ink-muted)' }}>{subtitle}</p>}
    </div>
);
